/**
 * Represents the type of pricing tier item
 */
export enum PricingTierItemTypeEnum {
	TIERED = 'tiered',
	FIXED = 'fixed',
}
